import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '@/stores'
import { subscriptionService } from '@/services/api'
import { useCurrentUser } from '@/hooks/api'

export function usePaymentSuccessPage() {
  const { t } = useTranslation('payment')
  const navigate = useNavigate()
  const setAuth = useAuthStore((state) => state.setAuth)

  const { data: currentUserData, isLoading: isUserLoading } = useCurrentUser()

  useEffect(() => {
    if (currentUserData?.user && currentUserData?.facility) {
      setAuth(currentUserData.user, currentUserData.facility)
    }
  }, [currentUserData, setAuth])

  const facilityId = currentUserData?.facility?.id

  const statusQuery = useQuery({
    queryKey: ['subscription', 'status', facilityId],
    queryFn: () => subscriptionService.getStatus(facilityId!),
    enabled: !!facilityId,
    refetchInterval: 2000,
    refetchIntervalInBackground: false,
  })

  const handleGoToDashboard = () => {
    navigate('/dashboard')
  }

  const isReady = statusQuery.data?.hasActiveSubscription

  return {
    t,
    isReady,
    isLoading: isUserLoading || (!isReady && statusQuery.isLoading),
    handleGoToDashboard,
  }
}
